import { useQuery } from '@tanstack/react-query';
import { getNetworkTopology, getRouteRecords } from '../api';

export const networkTopologyKeys = {
  all: ['network-topology'] as const,
  site: (siteId: string) => [...networkTopologyKeys.all, siteId] as const,
};

export function useNetworkTopology(siteId: string | null, autoRefresh = true) {
  return useQuery({
    queryKey: networkTopologyKeys.site(siteId!),
    queryFn: () => getNetworkTopology(siteId!),
    enabled: !!siteId,
    refetchInterval: autoRefresh ? 30_000 : false,
    staleTime: 15_000,
  });
}

export const routeRecordsKeys = {
  all: ['route-records'] as const,
  site: (siteId: string) => [...routeRecordsKeys.all, siteId] as const,
};

export function useRouteRecords(siteId: string | null, autoRefresh = true) {
  return useQuery({
    queryKey: routeRecordsKeys.site(siteId!),
    queryFn: () => getRouteRecords(siteId!),
    enabled: !!siteId,
    refetchInterval: autoRefresh ? 60_000 : false,
    staleTime: 30_000,
  });
}
